<div class="container">
  <h3>
    {{ title }}
  </h3>
  <p>
    {{ reason }}
  </p>

  <zaver-secondary-button-outlined
    *ngFor="let button of buttons"
    class="outlined-button"
    [rounded]="true"
    [text]="button.title"
    (click)="handleButtonClick(button)"
  ></zaver-secondary-button-outlined>
</div>
